import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { PackageService } from 'src/app/models/package-service.model';
import { PackageServiceService } from 'src/app/services/package-service.service';
import { ToastService } from 'src/app/services/toast.service';
import { PackageServiceFormComponent } from './package-service-form/package-service-form.component';
import { ServicePackageOrderFormComponent } from './service-package-order-form/service-package-order-form.component';
import { ProductService } from 'src/app/services/product.service';
import { Product } from 'src/app/models/product';

@Component({
  selector: 'app-package-services',
  templateUrl: './package-services.component.html',
  styleUrls: ['./package-services.component.scss']
})
export class PackageServicesComponent implements OnInit {

  packageServicesTable: PackageService[] = [];
  packageServices: PackageService[] = [];
  globalFilter: string = '';
  numberOfRows: number = 10;
  packageServiceStatus: boolean | null = null;
  products: Product[] = [];

  constructor(
    private translateService: TranslateService,
    private packageServiceService: PackageServiceService,
    private productService: ProductService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dialog: DialogService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.loadPackageServices();
    this.loadProducts();
  }

  loadProducts(): void {
    this.productService.getAll().subscribe({
      next: (data) => {
        this.products = data;
      },
      error: (error) => {
        console.error('Erro ao carregar produtos:', error);
        this.toastService.error('Erro ao carregar produtos');
      }
    });
  }

  loadPackageServices(): void {
    this.packageServiceService.findAll().subscribe({
      next: (data) => {
        this.packageServices = data;
        this.packageServicesTable = data;
      },
      error: (error) => {
        console.error('Erro ao carregar pacotes de serviço:', error);
        this.toastService.error('Erro ao carregar pacotes de serviço');
      }
    });
  }

  changePackageServiceFilter(value: boolean | null): void {
    this.packageServiceStatus = value;
  }

  filterGlobal(): void {
    if (!this.globalFilter || this.globalFilter.trim() === '') {
      this.packageServicesTable = this.packageServices;
    } else {
      const filterValue = this.globalFilter.toLowerCase();
      this.packageServicesTable = this.packageServices.filter(
        (packageService) =>
          packageService.name?.toLowerCase().includes(filterValue) ||
          packageService.description?.toLowerCase().includes(filterValue)
      );
    }
  }

  openDialog(packageService: PackageService | null): void {
    const ref = this.dialog.open(PackageServiceFormComponent, {
      header: packageService ? 'Editar Pacote de Serviço' : 'Novo Pacote de Serviço',
      width: '610px',
      data: {
        packageService: packageService,
        isEdit: !!packageService,
        products: this.products
      }
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        this.loadPackageServices();
      }
    });
  }

  edit(packageService: PackageService): void {
    this.openDialog(packageService);
  }

  deleteConfirm(packageService: PackageService): void {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja deletar este pacote de serviço?',
      accept: () => {
        this.delete(packageService);
      }
    });
  }

  delete(packageService: PackageService): void {
    this.packageServiceService.delete(packageService.id).subscribe({
      next: () => {
        this.toastService.success('Pacote de serviço deletado com sucesso');
        this.loadPackageServices();
      },
      error: (error) => {
        console.error('Erro ao deletar pacote de serviço:', error);
        this.toastService.error('Erro ao deletar pacote de serviço');
      }
    });
  }

  openServicePackageOrderDialog(): void {
    const ref = this.dialog.open(ServicePackageOrderFormComponent, {
      header: this.translateService.instant('NEW-SERVICE-PACKAGE-ORDER'),
      width: '700px',
      data: {
        servicePackageOrder: null,
        isEdit: false
      }
    });

    ref.onClose.subscribe((result) => {
      if (result) {
        // Quem for implementar a lógica de atualização dos pacotes de serviço na embarcação, deve implementar aqui
      }
    });
  }

  toggleStatus(packageService: PackageService): void {
    if (packageService.active) {
      this.packageServiceService.activate(packageService.id).subscribe({
        next: () => {
          this.toastService.success('Pacote de serviço ativado com sucesso');
        },
        error: (error) => {
          console.error('Erro ao ativar pacote de serviço:', error);
          this.toastService.error('Erro ao ativar pacote de serviço');
          packageService.active = false;
        }
      });
    } else {
      this.packageServiceService.deactivate(packageService.id).subscribe({
        next: () => {
          this.toastService.success('Pacote de serviço desativado com sucesso');
        },
        error: (error) => {
          console.error('Erro ao desativar pacote de serviço:', error);
          this.toastService.error('Erro ao desativar pacote de serviço');
          packageService.active = true;
        }
      });
    }
  }
}
